import CONFIG from '@/config/index';

export type MenuHeaderItem = {
  slug: string,
  name: string,
  path: string,
  currentApp?: boolean,
  clickable?: boolean,
  hidden?: boolean,
  children?: MenuHeaderItem[]
}
export const MENU_HEADER: MenuHeaderItem[] = [
  {
    slug: 'investments',
    name: 'Invest',
    path: CONFIG.isMarketEnabled ? '/investments' : '/investments/primary-offerings',
    clickable: !CONFIG.isMarketEnabled,
    children: CONFIG.isMarketEnabled ? [
      {
        name: 'Primary Offerings',
        path: '/investments/primary-offerings',
        slug: 'primary-offerings',
      },
      {
        name: 'Secondary Market',
        path: '/investments/secondary-market',
        slug: 'secondary-market',
      }] : [],
  },
  {
    slug: 'portfolio',
    name: 'Portfolio',
    path: '/portfolio',
  },
  {
    slug: 'farm-owners',
    name: 'For Farmers',
    path: '/resources/farm-owners',
  },
  {
    slug: 'advisors',
    name: 'For Advisors',
    path: '/advisors',
    currentApp: true,
  },
  {
    slug: 'resources',
    name: 'Resources',
    path: '/resources',
    children: [
      {
        slug: 'investors',
        name: 'Why Farmland Investing?',
        path: '/investors',
        currentApp: true,
      },
      {
        slug: 'how-it-works',
        name: 'How It Works',
        path: '/resources/how-it-works',
        currentApp: true,
      },
      {
        slug: 'faq',
        name: 'FAQs',
        path: '/faq',
      },
      {
        slug: 'learn',
        name: 'Learning Center',
        path: '/learn',
      },
      {
        slug: 'farmland-values',
        name: 'Farm Value Tool',
        path: '/resources/farmland-values/farmland-returns',
      },
      {
        slug: 'our-impact',
        name: 'Our Impact',
        path: '/company/our-impact',
        currentApp: true,
      },
      {
        slug: 'newsroom',
        name: 'Newsroom',
        path: '/newsroom',
      },
    ],
  },
];

export const PROFILE_MENU: MenuHeaderItem[] = [
  {
    name: 'Accounts',
    path: '/profile/accounts',
    slug: 'accounts',
  },
  {
    name: 'Beneficiaries',
    path: '/profile/beneficiary',
    slug: 'beneficiary',
  },
  {
    name: 'My Advisors',
    path: '/profile/my-advisors',
    slug: 'my-advisors',
  },
  {
    name: 'Tax Center',
    path: '/tax-center',
    slug: 'tax-center',
    currentApp: true,
  },
  {
    name: 'Notifications',
    path: '/profile/notifications',
    slug: 'notifications',
  },
  {
    name: 'Settings',
    path: '/profile/settings',
    slug: 'settings',
  },
];
